<template>
  <div
    class="modal-wrapper copy-move-modal"
    :class="{ 'modal-copy': action === 'copy' }"
  >
    <div class="modal">
      <div class="modal-header">
        <h1 v-if="action === 'copy'">{{ $t("copying") }}</h1>
        <h1 v-if="action === 'move'">{{ $t("move") }}</h1>
        <span class="tms modal-close" @click="close(false)">F</span>
      </div>
      <div class="modal-content" v-if="planning.date">
        <datepicker
          :language="bg"
          :inline="true"
          :monday-first="true"
          :minimumView="'day'"
          :maximumView="'day'"
          :full-month-name="true"
          :disabled-dates="{ dates: [new Date(planning.date)] }"
          :highlighted="selected"
          @selected="selectDate"
          v-model="date"
        ></datepicker>
      </div>
      <div class="modal-footer">
        <button class="btn btn-new" @click="save()">
          <span class="tms">Y</span>
          <template v-if="action === 'copy'">Копирай</template>
          <template v-if="action === 'move'">Премести</template>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { bg } from "vuejs-datepicker/dist/locale";
export default {
  components: {
    Datepicker: Datepicker,
  },
  props: ["action", "id"],
  data() {
    return {
      bg: bg,
      months: this.$t("months"),
      date: undefined,
      selected: {
        dates: [],
      },
      planning: {
        date: undefined,
      },
    };
  },
  methods: {
    selectDate(date) {
      if (this.action === "copy") {
        for (let [index, d] of this.selected.dates.entries()) {
          const slct = `${d.getDate()}/${d.getMonth()}/${d.getFullYear()}`;
          const nw = `${date.getDate()}/${date.getMonth()}/${date.getFullYear()}`;

          if (slct === nw) {
            this.selected.dates.splice(index, 1);
            return;
          }
        }
        this.selected.dates.push(date);
      }
    },
    getPlanning() {
      this.$store.dispatch("startLoading");
      let requestUrl = `${process.env.VUE_APP_BASE_URI}/planning/single/${this.id}`;
      this.$http
        .get(requestUrl)
        .then((response) => {
          console.log(response);
          this.planning = response.data;
          this.$store.dispatch("stopLoading");
        })
        .catch((err) => {
          console.log(err);
          this.$store.dispatch("stopLoading");
          this.$snotify.error(this.$t("something-went-wrong"));
          this.close(false);
        });
    },
    save() {
      if (this.action === "copy") {
        if (!this.selected.dates.length) {
          return this.$snotify.error("Моля изберете поне една дата");
        }
      } else {
        if (!this.date) {
          return this.$snotify.error("Моля изберете дата");
        }
      }

      const url = `${process.env.VUE_APP_BASE_URI}/planning/${this.planning._id}/${this.action}`;
      this.$http
        .put(url, this.action === "copy" ? this.selected : { date: this.date })
        .then((res) => {
          if (res.data.exists ? res.data.exists.length : false) {
            for (let e of res.data.exists) {
              this.$snotify.error(
                `Обекта е вече планиран за ${this.$options.filters.formatDate(
                  new Date(e)
                )}`
              );
            }

            return;
          }

          this.close(true);
        })
        .catch((error) => {
          console.log(error.response);
          this.$snotify.error(this.$t("something-went-wrong"));
        });
    },
    close(update) {
      this.$emit("close", update);
    },
  },
  mounted() {
    this.getPlanning();
  },
};
</script>

<style scoped>
.modal {
  width: initial;
}
.modal-header {
  justify-content: flex-start;
  padding: 0 30px;
}
.modal-header h1 {
  color: #fff;
  font-size: 20px;
}
.modal-footer {
  justify-content: center;
}
.btn {
  margin: 0;
}
/* Responsive */
@media screen and (max-width: 1000px) {
  .modal {
    max-height: 80vh;
    width: 90%;
  }
  .modal-header .new-input {
    width: 72%;
  }
}
@media screen and (max-width: 600px) {
  .modal-content-check {
    width: 45%;
  }
  .modal-footer {
    flex-direction: column;
    height: 97px;
  }
  .select-btns {
    margin: 10px 0;
  }
  .btn.btn-new {
    margin: 0 0 10px 0;
  }
}
@media screen and (max-width: 400px) {
  .modal-content-check {
    width: 100%;
  }
}
</style>
